import type { RunState } from '../../game/RunState';
import { junctionAt, signalAt } from '../../systems/junctions/signals';
import { el, setText } from '../components/el';

const SHOW_WITHIN = 110;
const LABEL = { green: 'Green, go!', amber: 'Amber, slow down', red: 'Red light, stop at the line' } as const;

/** Traffic light indicator for the junction ahead. */
export class SignalPrompt {
  private readonly root = el('div', 'signal');
  private readonly lamp = el('span', 'signal-lamp');
  private readonly text = el('span', 'signal-text');

  constructor(parent: HTMLElement) {
    this.root.append(this.lamp, this.text);
    parent.append(this.root);
  }

  update(state: RunState): void {
    const point = junctionAt(state.junction.seq);
    const toLine = point.stopLine - (state.bus.s + state.bus.size.length / 2);
    const visible = toLine > -2 && toLine < SHOW_WITHIN;
    this.root.classList.toggle('show', visible);
    if (!visible) return;
    const signal = signalAt(point.seq, state.stats.seconds);
    this.root.dataset.signal = signal;
    setText(this.text, `${point.junction.name} · ${Math.max(0, Math.round(toLine))} m · ${LABEL[signal]}`);
  }
}
